"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillDataInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var record_1 = require("../../model/record");
var service_1 = require("../../../library/base/service");
var BillDataInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BillDataInit, _super);
    function BillDataInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '高端理财交易记录初始化下拉框';
        _this.code = '101140';
        _this.desc = '高端理财交易记录初始化下拉框';
        _this.requestParams = new record_1.BillDataInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return BillDataInit;
}(service_1.BaseService));
exports.BillDataInit = BillDataInit;
//# sourceMappingURL=billDataInit.js.map